const skDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "Klonovať repozitár",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "Stiahnuť ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "Spravovať SSH kľúče",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "Tento priečinok je prázdny",
    description: "Message shown when directory has no contents",
  },
};

export default skDirectoryBrowse;
